<script lang="ts" setup>
	import type { BenefitHighlightContext, BenefitHighlightContextClass } from '../molecules/benefit-highlight.vue'

	defineProps<{
		highlightedBenefits: BenefitHighlightContext
		title?: string
		tag?: string
		largeOnMobile?: boolean
		ui?: Partial<BenefitHighlightContextClass> | undefined
	}>()
</script>

<template>
	<div class="flex flex-col items-center justify-center w-full">
		<slot name="header">
			<ui-title-tag v-if="!!tag" :tag />
			<ui-title-header
				:title
				:ui="{
					size: largeOnMobile
						? 'text-[2rem]/[2.4rem] md:text-[2.625rem]/[3.15rem] lg:text-[3.25rem]/[3.9rem]'
						: 'md:text-[3.25em] xs:text-[2em] text-[1.3em]',
					lineHeight: largeOnMobile ? '' : 'md:leading-[62.4px] xs:leading-[38.4px]'
				}"
				class="text-center md:max-w-[952px] md:mx-auto text-balance"
			/>
		</slot>
		<slot />

		<molecules-benefit-highlight :highlights="highlightedBenefits" class="sm:pt-20 flex-none w-full pt-2" :ui />
	</div>
</template>

<style></style>
